__turbopack_context__.v({
  "select": "Select-module__oRQPDa__select",
  "selectDisabled": "Select-module__oRQPDa__selectDisabled",
  "selectFullWidth": "Select-module__oRQPDa__selectFullWidth",
  "selectHiddenLabel": "Select-module__oRQPDa__selectHiddenLabel",
  "select__icon": "Select-module__oRQPDa__select__icon",
  "select__iconLoading": "Select-module__oRQPDa__select__iconLoading",
  "select__placeholder": "Select-module__oRQPDa__select__placeholder",
  "select__select": "Select-module__oRQPDa__select__select",
  "select__select__selectContainer": "Select-module__oRQPDa__select__select__selectContainer",
});
